import { connect } from 'react-redux';
import { SubmissionError, change, untouch } from 'redux-form';
import { browserHistory } from 'react-router';
import { loadCAWarranty, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import validate from '../components/Validations/submitValidationsWarrantyForm'
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import CAWarrantyForm from '../components/CAWarrantyForm.js';

const mapStateToProps = (state) => {

    return {
        isValidating: false,
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        //For any field errors upon submission (i.e. not instant check)
        addCAWarrantyType(values, dispatch, ownProps) {
            dispatch(submitForm());
            return dispatch(loadCAWarranty(values)).then((result) => {
                if (result.payload.status !== 200) {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError ({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                } else {
                    dispatch(getNextStep()).then((result) => {
                        if (typeof(result.payload.data.endpoint) !== 'undefined') {
                            sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                            dispatch(stopSubmitForm());
                            browserHistory.push(result.payload.data.endpoint);
                        }
                    });
                }
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CAWarrantyForm);



/** WEBPACK FOOTER **
 ** ./src/containers/CAWarrantyFormContainer.js
 **/